import { useTranslation } from 'react-i18next';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export default function QuizNavigation({ currentStep, totalSteps, loading, onBack, onNext, onSubmit }) {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between mt-8 pt-6 border-t">
      <button
        onClick={onBack}
        disabled={currentStep === 1}
        className="flex items-center gap-2 px-4 py-2 rounded-md border border-border text-foreground disabled:opacity-40 disabled:cursor-not-allowed hover:bg-muted"
        data-testid="quiz-back-btn"
      >
        <ArrowLeft className="w-4 h-4" />
        {t('quiz.back')}
      </button>

      {currentStep < totalSteps ? (
        <button
          onClick={onNext}
          className="btn-primary flex items-center gap-2 px-6 py-2 rounded-md"
          data-testid="quiz-next-btn"
        >
          {t('quiz.next')}
          <ArrowRight className="w-4 h-4" />
        </button>
      ) : (
        <button
          onClick={onSubmit}
          disabled={loading}
          className="btn-primary flex items-center gap-2 px-6 py-2 rounded-md disabled:opacity-50"
          data-testid="quiz-submit-btn"
        >
          {loading ? t('quiz.generating') : t('quiz.submit')}
          <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
